import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import sliderData from "./SliderData";
import '../src/css/HomeSlider.css';
import slider_click from '../src/imgs/slider_click_icon.svg';

export const HomeSlider = () => {
    const [slider] = useState(sliderData);
    const [index, setIndex] = useState(0);
  
    function activeSlide() {
      var Slide1: any = document.getElementById("slide1");
      var Slide2: any = document.getElementById("slide2");
      var Slide3: any = document.getElementById("slide3");
      var Slide4: any = document.getElementById("slide4");
  
      var screenSlide1: any = document.getElementById("slideScreen1");
      var screenSlide2: any = document.getElementById("slideScreen2");
      var screenSlide3: any = document.getElementById("slideScreen3");
      var screenSlide4: any = document.getElementById("slideScreen4");
  
      if (Slide1.classList.contains("activeSlide")) {
        screenSlide1.classList.add("screenSlide2Active");
        screenSlide2.classList.remove("screenSlide2Active");
        screenSlide3.classList.remove("screenSlide2Active");
        screenSlide4.classList.remove("screenSlide2Active");
      } else if (Slide2.classList.contains("activeSlide")) {
        screenSlide2.classList.add("screenSlide2Active");
        screenSlide1.classList.remove("screenSlide2Active");
        screenSlide3.classList.remove("screenSlide2Active");
        screenSlide4.classList.remove("screenSlide2Active");
      } else if (Slide3.classList.contains("activeSlide")) {
        screenSlide3.classList.add("screenSlide2Active");
        screenSlide1.classList.remove("screenSlide2Active");
        screenSlide2.classList.remove("screenSlide2Active");
        screenSlide4.classList.remove("screenSlide2Active");
      } else if (Slide4.classList.contains("activeSlide")) {
        screenSlide4.classList.add("screenSlide2Active");
        screenSlide1.classList.remove("screenSlide2Active");
        screenSlide2.classList.remove("screenSlide2Active");
        screenSlide3.classList.remove("screenSlide2Active");
      }
    }
  
    useEffect(() => {
      activeSlide();
      const lastIndex = slider.length - 1;
  
      if (index < 0) {
        setIndex(lastIndex);
        activeSlide();
      }
  
      if (index > lastIndex) {
        setIndex(0);
        activeSlide();
      }
    }, [index, slider]);
  
    useEffect(() => {
      activeSlide();
      let sliderInterval: any;
      try {
        sliderInterval = setInterval(() => {
          setIndex(index + 1);
        }, 5000);
      } catch (e) {
        console.error(e);
      }
      return () => clearInterval(sliderInterval);
    }, [index]);
    return (

        <>

            <div className="slide_screens" id="idslide_screens">

                {slider.map((slide: any) => {
                    
                    const { id, title, icon, active, screenID, url, clase } = slide;
                    
                    return (

                        <Link key={id} to={url}>
                            <div id={'smallImage'+screenID} className={'smallImagesScreen' + ' ' + clase} onClick={activeSlide}>    
                                <div id={'slideScreen' + id} className={'screen2 screenSlide2'} onClick={active} >
                                    <div className="screen_icon"> 
                                        <img src={icon} alt={title} />
                                    </div>
                                    <div className="screen_caption">
                                        <p>{title}</p>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    );
                })}

            </div>

            <div className='home_slide_area' id="idhome_slider_area">

                {slider.map((slide: any, slideIndex: any) => {

                    const { id, image, title, quote, url, key, screenID, ir } = slide;
                    let position = "nextSlide";

                    if (slideIndex === index) {
                        position = "activeSlide";
                    }

                    if (
                        slideIndex === index - 1 ||
                        (index === 0 && slideIndex === slider.length - 1)
                    ) {
                        position = "lastSlide";
                    }

                    return (
                        <React.Fragment key={slideIndex}>
                            <Link to={url}>
                                
                                <div id={'bigImage'+screenID} className="smallScreenArea">

                                    <div id={'slide' + id} key={key} className={position + ' slide_content'} data-id="1">
                                        
                                        <div className="slide_image_back">
                                            <img src={image} alt={'Instuto Nacional de Administracion publica INAP ' + title} />
                                        </div>
                                        <div className="slide_image">
                                            <img src={image} alt={'Instuto Nacional de Administracion publica INAP ' + title} />
                                        </div>
                                        <div className="slide_preinfo">
                                            <h2 className="preinfo_titulo">{title}</h2>
                                            <p className="preinfo_contenido">{quote}</p>
                                            <p className="preinfo_ir">{ir}</p>
                                            <img src={slider_click} alt={'Click para ir a sección'} />
                                        </div>
                                    </div>

                                </div>

                            </Link>

                            </React.Fragment>

                    );
                })}

            </div>

            <div className="slide_controls" id="idslide_controls">
                <button className="prev" onClick={() => setIndex(index - 1)}>
                    <BsChevronLeft /> anterior
                </button>

                <button className="next" onClick={() => setIndex(index + 1)}>
                    siguiente <BsChevronRight />
                </button>
            </div>

        </>

    )
}